import { render, staticRenderFns } from "./BotaoInteligenciaCarbono.vue?vue&type=template&id=3d7a0e86&lang=pug"
import script from "./BotaoInteligenciaCarbono.vue?vue&type=script&lang=js"
export * from "./BotaoInteligenciaCarbono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports